<template>
  <div v-if="data">
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <!-- numOfScrAnswers starts on 1 since question about FH diagnosis is not part of the actual screening -->
          <div class="card dashboard-card" v-if="!hasCreatedRemittance && numOfScrAnswers > 1">
            <div class="header-wrapper">
              <h4 class="text-primary-fh">Saknas din remiss?</h4>
            </div>
            <router-link to="/createremittance" class="btn btn-primary btn-block btn-sm">
              Skapa remiss på nytt
            </router-link>
            <div class="clearfix--min"></div>
            <small>
              Finns inte knappen <b>Till frågor och remisskapande</b> nedanför på denna sida så kan du använda ovanstående.
            </small>
          </div>
        </div>
        <div class="col-md-6">
          <!-- Har EJ skapat remiss -->
          <div v-if="!hasCreatedRemittance">
            <div class="header-wrapper">
              <h2 class="text-primary-fh h2--size" v-html="data.dashboard.welcomeHeader"></h2>
              <h2 class="text-primary-fh h2--size">{{ toTitleCase(fullname) }}!</h2>
            </div>
            <p v-html="data.dashboard.welcomeText"></p>
          </div>
          <!-- Har skapat remiss och inte tagit ett blodprov -->
          <div v-if="hasCreatedRemittance && !hasTakenBloodTest">
            <div class="header-wrapper">
              <h2 class="text-primary-fh left-header" v-html="data.dashboard.welcomeremittanceheader"></h2>
            </div>
            <p v-html="data.dashboard.welcomeremittancetext"></p>
          </div>
          <!-- Har skapat remiss, tagit blodprov och tagit gentest samt är FH negativ -->
          <!-- <div v-if="hasCreatedRemittance && hasTakenBloodTest && hasTakenGenTest && gentestData.geneticTestAssessment === 1"> -->
          <div v-if="hasCreatedRemittance && hasTakenBloodTest && hasTakenGenTest && (hasDiagnosis && diagnosisData.fhDiagnosisValue === 2)">
            <div class="header-wrapper">
              <h2 class="text-primary-fh left-header" v-html="data.dashboard.welcomegenresultsHeader"></h2>
            </div>
            <p v-html="data.dashboard.welcomegenresultsPositiveText"></p>
          </div>
          <!-- <div v-if="hasCreatedRemittance && hasTakenBloodTest && hasTakenGenTest && gentestData.geneticTestAssessment === 2"> -->
          <div v-if="hasCreatedRemittance && hasTakenBloodTest && hasTakenGenTest && (hasDiagnosis && diagnosisData.fhDiagnosisValue === 4)">
            <div class="header-wrapper">
              <h2 class="text-primary-fh left-header" v-html="data.dashboard.welcomegenresultsHeader"></h2>
            </div>
            <p v-html="data.dashboard.welcomegenresultsNegativeText"></p>
          </div>
          <!-- Har skapat remiss, tagit blodprov och tagit gentest samt är FH positiv -->
          <div class="card dashboard-card" v-if="hasCreatedRemittance && hasTakenBloodTest && hasDiagnosis">
            <!-- Om bedömning är utförd gällande diagnosis från det kliniska interfacet -->
            <p class="text-dark">
              <strong>Från vårdgivaren</strong>:
              <!-- {{ getDecisionText(diagnosisData.fhDiagnosisValue) }} -->
              <br />
              {{ diagnosisData.patientText || 'Här kommer meddelande från din vårdgivare att visas' }}
            </p>
          </div>
          <!-- Tillhör INTE Region Skåne -->
          <div v-if="!ifRegionIsSkane && hasCreatedRemittance && hasTakenBloodTest && hasTakenGenTest
            && (hasDiagnosis && (diagnosisData.fhDiagnosisValue === 1 || diagnosisData.fhDiagnosisValue === 2))">
            <div class="card dashboard-card" v-show="!referralToRegionCreated">
              <h5 class="text-primary-fh left-header">Ta kontakt med en läkare</h5>
              <p>Välj i listan vilket vårdställe som passar dig bäst.</p>
              <select class="form-control" v-model="careCenter">
                <option :value="0">Ange vårdställe</option>
                <option v-for="(region, center) in data.misc.facilitylist" :value="center" v-bind:key="center">
                  {{ center }}
                </option>
              </select>
              <div class="clearfix"></div>
              <p class="text-primary-fh text-center">..eller skriv i fritext. Var noga med stavningen.</p>
              <input
                class="form-control form-control-lg"
                type="text"
                v-model="careFacility"
                placeholder="Exempelvis: Huddinge vårdcentral"
              />
              <div class="clearfix"></div>
              <button
                class="btn btn-primary btn-lg btn-block create-remittance-btn"
                :disabled="(careCenter === 0 && careFacility.length === 0)"
                @click="referralToRegion()">
              Skapa remiss
              </button>
            </div>
            <div class="card dashboard-card bg-light" v-show="referralToRegionCreated">
              <h5 class="text-dark left-header">Kallelse skickas med post</h5>
                <p class="text-dark" v-html="data.dashboard.referralToRegionText"></p>
                <p class="text-dark">
                  Du kommer att få en kallelse med brev från {{ (careCenter || careFacility) || ' din valda mottagning' }}.
                </p>
            </div>
          </div>
          <!-- Tillhör Region Skåne -->
          <div v-if="ifRegionIsSkane && hasCreatedRemittance && hasTakenBloodTest && hasTakenGenTest
            && (hasDiagnosis && (diagnosisData.fhDiagnosisValue === 1 || diagnosisData.fhDiagnosisValue === 2))">
            <div class="card dashboard-card bg-light">
              <p class="text-dark" v-html="data.dashboard.referralToRegionSkaneText"></p>
              <img
              :src="require( `../assets/img/regioner/SE162321000255/header.svg`)"
              alt="Header för Region Skåne"
              class="img-logo" />
            </div>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <!-- Lista provtagningsställen (om skapat remiss) -->
          <div class="card dashboard-card pulse" v-if="hasCreatedRemittance && !hasTakenBloodTest">
            <h5 class="text-primary-fh left-header">Lista provtagningsställen</h5>
            <p>Karolinska samt Unilabs har provtagningsställen, klicka nedan på en av länkarna för en komplett lista.</p>
            <a href="https://www.karolinska.se/for-patienter/karolinska-universitetslaboratoriet/alla-provtagningsenheter-a-o/"
            target="_blank"
            class="text-primary-fh left-header">
              <img src="@/assets/img/external-link.svg?data" alt="Ikon för extern länk" class="img-fluid" />
              <span> Provtagningsställen (Karolinska)</span>
            </a>
            <a href="https://unilabs.se/privatperson/laboratorie-medicin/provtagning"
            target="_blank"
            class="text-primary-fh left-header samplepoints-link">
              <img src="@/assets/img/external-link.svg?data" alt="Ikon för extern länk" class="img-fluid" />
              <span> Provtagningsställen (Unilabs)</span>
            </a>
          </div>
          <!-- Har skapat remiss och tagit blodprov -->
          <div v-if="hasCreatedRemittance && hasTakenBloodTest && !hasTakenGenTest">
            <div class="card dashboard-card">
              <h5 class="text-primary-fh left-header">Provsvar</h5>
              <p v-html="data.dashboard.labresultsCardText"></p>
              <small class="text-right">{{ getTestDate(bloodtestData) }}</small>
              <ul class="ul-list list-group list-group-flush bg-transparent">
                <li class="list-group-item bg-transparent">
                  Totalkolesterol <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.totalKolesterol }} {{ bloodtestData.totalKolesterolUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  Triglycerider <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.triglycerider }} {{ bloodtestData.triglyceriderUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  HDL kolesterol <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.hdl }} {{ bloodtestData.hdlUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  LDL kolesterol <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.ldl }} {{ bloodtestData.ldlUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  Lipoprotein (a) <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.lipoProteinA }} {{ bloodtestData.lipoProteinAUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
              </ul>
              <ul class="ul-list list-group list-group-flush bg-transparent">
                <div class="clearfix"></div>
                <p v-html="data.dashboard.referenceIntervalText"></p>
                <li class="list-group-item bg-transparent">
                  Totalkolesterol
                  <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.totalKolesterolReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  Triglycerider
                  <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.triglyceriderReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  HDL kolesterol
                  <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.hdlReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  LDL kolesterol
                  <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.ldlReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
              </ul>
            </div>
            <!-- Om bedömning är utförd gällande blodprovet från det kliniska interfacet -->
            <div class="card dashboard-card" v-if="assessmentData && assessmentData.bloodSampleAssessmentValue !== 0">
              <p class="text-dark">
                <strong>Från vårdgivaren</strong>:
                <!-- {{ getAssessmentText(assessmentData.bloodSampleAssessmentValue) }} -->
                <br />
                {{ assessmentData.patientText || 'Här kommer meddelande från din vårdgivare att visas' }}
              </p>
            </div>
            <div class="clearfix"></div>
            <!-- Genetiskt test provtagning från DatoCMS -->
            <div class="card dashboard-card" v-if="assessmentData && assessmentData.bloodSampleAssessmentValue === 4">
              <h5 class="text-primary-fh left-header" v-html="data.dashboard.genTestSamplingHeader"></h5>
              <p v-html="data.dashboard.genTestSamplingText"></p>
            </div>
            <div class="clearfix"></div>
            <div class="card dashboard-card">
              <p v-html="data.dashboard.sampleEquipmentText"></p>
              <!-- <a href="https://www.karolinska.se/for-patienter/karolinska-universitetslaboratoriet/alla-provtagningsenheter-a-o/"
              target="_blank"
              class="text-primary-fh left-header samplepoints-link">
                <img src="@/assets/img/external-link.svg?data" alt="Ikon för extern länk" class="img-fluid" />
                <span> Provtagningsställen (Karolinska)</span>
              </a> -->
              <a href="https://unilabs.se/privatperson/laboratorie-medicin/provtagning"
              target="_blank"
              class="text-primary-fh left-header samplepoints-link">
                <img src="@/assets/img/external-link.svg?data" alt="Ikon för extern länk" class="img-fluid" />
                <span> Provtagningsställen (Unilabs)</span>
              </a>
            </div>
          </div>
          <!-- Har skapat remiss, tagit blodprov och gentest -->
          <!-- <div v-if="hasCreatedRemittance && hasTakenBloodTest && (hasTakenGenTest && gentestData.geneticTestAssessment === 1)"> -->
          <div v-if="hasCreatedRemittance && hasTakenBloodTest && hasTakenGenTest &&
          (hasDiagnosis && (diagnosisData.fhDiagnosisValue === 2 || diagnosisData.fhDiagnosisValue === 4))">
            <div class="card dashboard-card">
              <h5 class="text-primary-fh left-header">Resultat av ditt gentest</h5>
              <p v-if="gentestData.mutation" v-html="data.dashboard.genTestMutationPositiveText"></p>
              <p v-if="gentestData.mutation">{{gentestData.mutation}}</p>
              <p v-if="!gentestData.mutation" v-html="data.dashboard.genTestMutationNegativeText"></p>
              <a
                href="https://www.karolinska.se/for-vardgivare/karolinska-universitetslaboratoriet/klinisk-genetik/"
                target="_blank"
                class="text-primary-fh left-header samplepoints-link"
              >
                <img src="@/assets/img/external-link.svg?data" alt="Ikon för extern länk" class="img-fluid" />
                <span> Läs mer om genmutationer</span>
              </a>
            </div>
            <div class="card dashboard-card">
              <h5 class="text-primary-fh left-header">Provsvar</h5>
              <p v-html="data.dashboard.labresultsCardText"></p>
              <!-- Om bedömning är utförd gällande blodprovet från det kliniska interfacet -->
              <div class="card dashboard-card" v-if="assessmentData && assessmentData.bloodSampleAssessmentValue !== 0">
                <p class="text-dark">
                  <strong>Från vårdgivaren</strong>:
                  <!-- {{ getAssessmentText(assessmentData.bloodSampleAssessmentValue) }} -->
                  <br />
                  {{ assessmentData.patientText || 'Här kommer meddelande från din vårdgivare att visas' }}
                </p>
              </div>
              <small class="text-right">{{ getTestDate(bloodtestData) }}</small>
              <ul class="ul-list list-group list-group-flush bg-transparent">
                <li class="list-group-item bg-transparent">
                  Totalkolesterol <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.totalKolesterol }} {{ bloodtestData.totalKolesterolUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  Triglycerider <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.triglycerider }}  {{ bloodtestData.triglyceriderUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  HDL kolesterol <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.hdl }} {{ bloodtestData.hdlUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  LDL kolesterol <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.ldl }}
                    {{ bloodtestData.ldlUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  Lipoprotein (a) <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.lipoProteinA }} {{ bloodtestData.lipoProteinAUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
              </ul>
              <ul class="ul-list list-group list-group-flush bg-transparent">
                <div class="clearfix"></div>
                <p v-html="data.dashboard.referenceIntervalText"></p>
                <li class="list-group-item bg-transparent">
                  Totalkolesterol
                  <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.totalKolesterolReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  Triglycerider
                  <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.triglyceriderReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  HDL kolesterol
                  <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.hdlReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  LDL kolesterol
                  <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.ldlReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- Har EJ skapat remiss -->
          <div class="card dashboard-card" v-if="!hasCreatedRemittance">
            <h5 class="text-primary-fh left-header" v-html="data.dashboard.remittanceHeader"></h5>
            <p>Här kan du skapa en remiss till provtagning av:</p>
            <ul class="ul-list">
              <li>Totalkolesterol</li>
              <li>Triglycerider</li>
              <li>HDL kolesterol</li>
              <li>LDL kolesterol</li>
              <li>Lipoprotein (a)</li>
            </ul>
            <router-link
              to="/screeningmed"
              class="btn btn-primary btn-block btn-lg">
              {{ data.dashboard.startscreeningandremittancebtn }}
            </router-link>
          </div>
          <!-- Har tagit prover -->
          <div class="card dashboard-card no-border" v-if="hasCreatedRemittance && hasTakenBloodTest">
            <h5 class="text-primary-fh left-header" v-html="data.dashboard.samplesdoneheader"></h5>
          </div>
          <!-- Har skapat remiss -->
          <div class="card dashboard-card no-border" v-if="hasCreatedRemittance">
            <h5 class="text-primary-fh left-header" v-html="data.dashboard.remittancedoneheader"></h5>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <!-- Har bekräftat släktskap -->
          <div class="card dashboard-card no-border">
            <h5 class="text-primary-fh left-header" v-html="data.dashboard.kinshipHeader"></h5>
          </div>
          <!-- Logga ut -->
          <div class="card dashboard-card no-border" v-if="hasCreatedRemittance">
            <h5 class="font-weight-bold text-primary-fh left-header" v-html="data.dashboard.doneLogOutHeader"></h5>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import { request } from '../plugins/datocms'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'dashboard',
  components: {
    Top,
    Bottom
  },
  data () {
    return {
      data: null,
      fullname: '',
      careCenter: 0,
      careFacility: '',
      hasDiagnosis: false,
      hasCreatedRemittance: false,
      hasTakenBloodTest: false,
      hasTakenGenTest: false,
      assessmentData: null,
      bloodtestData: null,
      gentestData: null,
      diagnosisData: null,
      referralToRegionCreated: false,
      numOfScrAnswers: 0,
      region: sessionStorage.getItem('region')
    }
  },
  methods: {
    getAssessmentText (value) {
      switch (value) {
        case 1:
          return 'Låga värden'
        case 2:
          return 'Måttliga värden'
        case 3:
          return 'Höga värden'
        case 4:
          return 'Bedömningen behöver kompletteras med ett genetiskt test'
        case 5:
          return 'Annan orsak, se meddelande från vårdgivare'
        default:
      }
    },
    getDecisionText (value) {
      switch (value) {
        case 1:
          return 'Bekräftad Familjär Hyperkolesterolomi utifrån lipidvärden'
        case 2:
          return 'Bekräftad Familjär Hyperkolesterolomi utifrån genetiskt test'
        case 3:
          return 'Ingen Familjär Hyperkolesterolemi utifrån lipidvärden'
        case 4:
          return 'Ingen Familjär Hyperkolesterolemi utifrån genetiskt test'
        case 5:
          return 'Annan orsak, se meddelande från vårdgivare'
        default:
      }
    },
    getTestDate (bloodtest) {
      if (bloodtest !== null) {
        return new Date(bloodtest.testDate).toLocaleDateString()
      } else {
        return '-'
      }
    },
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    async checkForBloodTestAndAssessment () {
      axios._get(config.bloodtestUri).then(response => {
        if (response) {
          this.bloodtestData = response.data.bloodTest
          this.assessmentData = response.data.assessment
          if (this.bloodtestData) {
            try {
              const LDLs = JSON.parse(this.bloodtestData.ldl)
              this.bloodtestData.ldl = LDLs.ldlHighestMeasured
                ? LDLs.ldlHighestMeasured.replace(/,/g, '.') : LDLs.ldlUncalculated.replace(/,/g, '.')
            } catch (error) {
              console.log(error)
            }
          }
          if (this.bloodtestData && this.assessmentData.bloodSampleAssessmentValue !== 0) {
            this.hasTakenBloodTest = true
          }
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get bloodtest: ' + error)
        }
      })
    },
    async checkForReferral () {
      axios._get(config.referralUri).then(response => {
        if (response) {
          this.hasCreatedRemittance = response.data.isValid
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get if patient has referral: ' + error)
        }
      })
    },
    async checkForGenTest () {
      axios._get(config.gentestUri).then(response => {
        if (response) {
          this.gentestData = response.data.geneticTestData
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get gentest: ' + error)
        }
      })
    },
    async checkForDiagnosis () {
      let loader = this.$loading.show({
        opacity: 0.9,
        backgroundColor: '#B5B5B5'
      })
      axios._get(config.diagnosisUri).then(response => {
        if (response) {
          this.diagnosisData = response.data.fhDiagnosis
          if (this.diagnosisData && this.diagnosisData.fhDiagnosisValue !== 0) {
            if (this.diagnosisData.fhDiagnosisValue === 2) {
              this.hasTakenGenTest = true
            }
            this.hasDiagnosis = true
          }
          loader.hide()
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get diagnosis: ' + error)
          loader.hide()
        }
      })
    },
    async getNumOfScreeningAnswers () {
      axios._get(config.screeningAnswerUri).then(response => {
        if (response) {
          this.numOfScrAnswers = response.data.answers.length
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Request went bad to screeninganswers: ' + error)
        }
      })
    },
    referralToRegion () {
      let loader = this.$loading.show({
        opacity: 0.9,
        backgroundColor: '#B5B5B5'
      })
      const healthCenter = (this.careCenter !== 0) ? this.careCenter : this.careFacility
      if (healthCenter.length > 0) {
        axios.postReferralHealthCenter(config.referralHealthcenterUri, healthCenter).then((response) => {
          if (response.status === 200) {
            this.referralToRegionCreated = true
            loader.hide()
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      }
    }
  },
  computed: {
    ifRegionIsSkane () {
      if (this.region && this.region === 'SE162321000255') {
        return true
      } else {
        return false
      }
    }
  },
  async beforeMount () {
    sessionStorage.removeItem('hasVisitedDashboardNoReferral')
    sessionStorage.setItem('hasVisitedDashboard', 'true')
    this.fullname = sessionStorage.getItem('fullname')
    this.hasCreatedRemittance = (localStorage.getItem('remittance') === 'true')
    if (!this.hasCreatedRemittance) {
      await this.checkForReferral()
      await this.getNumOfScreeningAnswers()
    }
    await this.checkForBloodTestAndAssessment()
    await this.checkForGenTest()
    await this.checkForDiagnosis()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          dashboard {
            welcomeHeader
            welcomeText
            remittanceHeader
            samplesdoneheader
            remittancedoneheader
            kinshipHeader
            doneLogOutHeader
            welcomeremittanceheader
            welcomeremittancetext
            welcomegenresultsHeader
            welcomegenresultsPositiveText
            welcomegenresultsNegativeText
            labresultsCardText
            startscreeningandremittancebtn
            referenceIntervalText
            genTestSamplingHeader
            genTestSamplingText
            genTestMutationNegativeText
            genTestMutationPositiveText
            referralToRegionText
            referralToRegionSkaneText
            sampleEquipmentText
          }
          misc {
            facilitylist
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-top: 125px;
  margin-bottom: 50px;
  min-height: 65vh;
}
@media screen and (min-width: 800px) {
  .header-wrapper {
    display: flex;
  }
}
.create-remittance-btn {
  margin-bottom: 1vh;
}
.img-logo {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 10px;
  width: 10%;
}
.ul-list {
  border-top: 0;
  text-align: left;
  display: inline-grid;
}
.h2--size {
  font-size: 166%;
}
.left-header {
  text-align: left;
}
.text-right {
  display: inline;
  position: absolute;
  top: 0;
  right: 0;
  margin: 1.5em;
}
.margin-left {
  margin-left: 30px;
}
.lab-results-values {
  float: right;
  font-weight: bold;
  font-size: 1.1em;
}
.samplepoints-link span {
  vertical-align: text-top;
}
.dashboard-card {
  padding: 15px 15px 15px 15px;
  background: #e5f1f5;
  margin-bottom: 25px;
  border: 2px solid #069ccc;
  border-radius: 15px;
}
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue